import Button from '@mui/material/Button';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import TimelineIcon from '@mui/icons-material/Timeline';
import { keyframes } from '@mui/system';
import FireIcon from '@mui/icons-material/Whatshot';
import Box from '@mui/material/Box';

export default function Buttons(props) {
    const blink = keyframes`
    from { opacity: 0.3; }
     to { opacity: 1; }
    `;
    const bottomOffsetMobile = 60 + 56;
    const bottomOffsetDesktop = 150;
    const buttonSpaceBetween = 56 + 15;
    return (<>
        <Box>

            {/* {props.inIframe &&
                <Button
                    color="primary"
                    aria-label="treeType"
                    variant="contained"
                    onClick={() => props.fullScreen()}
                    sx={{
                        position: 'absolute',
                        right: props.leftOffset,
                        zIndex: 2000,
                        ...(props.mobile ? { bottom: bottomOffsetMobile + buttonSpaceBetween * 2 } : { bottom: bottomOffsetDesktop + buttonSpaceBetween * 2 }),
                    }}>
                    <FullscreenIcon />
                </Button>} */}


            <Button
                aria-label="burn"
                variant="contained"
                onClick={() => props.mapButtonClicked("FIRE")}
                disabled={props.leftSubDrawerType === "FIRE"}
                sx={{
                    position: 'fixed',
                    ...(props.mobile ? { bottom: bottomOffsetMobile + 2 * buttonSpaceBetween } : { bottom: bottomOffsetDesktop + 2 * buttonSpaceBetween }),
                    right: props.leftOffset,
                    zIndex: 2000,

                    border: 0,
                    // borderRadius: 3,
                    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
                    color: 'white',

                }}>
                <FireIcon sx={{ color: 'red', animation: `${blink} 1.5s linear infinite` }} />
            </Button>
            <Button
                color="primary"
                aria-label="treeType"
                variant="contained"
                onClick={() => props.mapButtonClicked("BAUMARTEN")}
                disabled={props.leftSubDrawerType === "BAUMARTEN"}
                sx={{
                    position: 'fixed',
                    ...(props.mobile ? { bottom: bottomOffsetMobile + buttonSpaceBetween } : { bottom: bottomOffsetDesktop + buttonSpaceBetween }),
                    right: props.leftOffset,
                    zIndex: 2000,
                }}>
                <DonutLargeIcon />
            </Button>

            <Button
                color="primary"
                aria-label="schadflaechen"
                variant="contained"
                onClick={() => props.mapButtonClicked("LAYER")}
                disabled={props.leftSubDrawerType === "LAYER"}
                sx={{
                    position: 'fixed',
                    ...(props.mobile ? { bottom: bottomOffsetMobile } : { bottom: bottomOffsetDesktop }),
                    right: props.leftOffset,
                    zIndex: 2000,
                }}
            >
                <TimelineIcon />
            </Button>
        </Box>
    </>);
}
